// extracted by mini-css-extract-plugin
export default {"text-linkk":"Breadcrumb_text-linkk__6vOP8"};